import layout from '@/views/layout/layout.vue'
const aliyunsmsList = r => require.ensure([], () => r(require('@/views/system/aliyunsms/list.vue')), 'group-system-aliyunsms')
const smslogList = r => require.ensure([], () => r(require('@/views/system/aliyunsms/smsloglist.vue')), 'group-system-aliyunsms')

const systemAliyun = [
  {
    path: '/system/aliyunsms',
    name: 'system-aliyunsms',
    component: layout,
    redirect: '/system/aliyunsms/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: aliyunsmsList,
        name: 'system-aliyunsms-list',
        meta: {
          displayName: '短信配置',
          requireAuth: true
        }
      },
      {
        path: 'smsloglist',
        component: smslogList,
        name: 'system-aliyunsms-smslogList',
        meta: {
          displayName: '短信日志',
          requireAuth: true
        }
      }
    ]
  }
]

export default systemAliyun



// WEBPACK FOOTER //
// ./src/router/system/aliyunsms.js